// extracted by mini-css-extract-plugin
export default {"loadingPage":"Loader_loadingPage__yKt0G","logo":"Loader_logo__j3Pdy","ldsSpinner":"Loader_ldsSpinner__5HC+f"};